<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">مشاوره و طراحی راهکارهای تکنولوژی برای کسب‌وکارها</h3>
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">خدمات مشاوره و طراحی راهکارهای تکنولوژی ما برای کسب‌وکارها</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در عصر دیجیتال، بهره‌گیری از تکنولوژی‌های نوین نه‌تنها یک انتخاب بلکه یک ضرورت برای کسب‌وکارهاست. ما با ارائه خدمات مشاوره و طراحی تکنولوژی، به سازمان‌ها، شرکت‌ها و استارتاپ‌ها کمک می‌کنیم تا با استفاده از فناوری‌های نوین، بهبود بهره‌وری، کاهش هزینه‌ها و افزایش نوآوری را تجربه کنند. تیم متخصص ما با ترکیب دانش فنی و تجربه صنعتی، راهکارهایی متناسب با نیازهای خاص هر کسب‌وکار ارائه می‌دهد.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">نیازهای کسب‌وکارها و چالش‌های موجود</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>عدم شناخت کافی از تکنولوژی‌های نوین:</strong>  بسیاری از شرکت‌ها از مزایای تکنولوژی‌های جدید بی‌اطلاع هستند یا روش پیاده‌سازی آن‌ها را نمی‌دانند.
                                </li>
                                <li class="mt-3">
                                    <strong>نیاز به استراتژی دیجیتالی:</strong> سازمان‌ها برای ماندگاری در رقابت، نیاز به برنامه‌ای منسجم برای تحول دیجیتال دارند.
                                </li>
                                <li class="mt-3">
                                    <strong>هزینه‌های بالای توسعه و پیاده‌سازی فناوری:</strong> انتخاب نادرست تکنولوژی می‌تواند منجر به هزینه‌های غیرضروری و ناکارآمدی شود.
                                </li>
                                <li class="mt-3">
                                    <strong>امنیت و مدیریت داده‌ها:</strong> استفاده از فناوری‌های نوین نیازمند یکپارچه‌سازی با سیستم‌های موجود و تأمین امنیت داده‌های سازمان است.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما در مشاوره و طراحی تکنولوژی</h3>
                <h6>ما طیف وسیعی از خدمات را ارائه می‌دهیم که شامل:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> تدوین استراتژی دیجیتال و تحول فناوری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل وضعیت فعلی سازمان و ارائه راهکارهای دیجیتالی‌سازی</li>
                                <li>طراحی نقشه راه تحول دیجیتال متناسب با اهداف سازمان</li>
                                <li>مشاوره در زمینه پیاده‌سازی فناوری‌های نوین برای بهبود عملکرد</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img22.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مشاوره در انتخاب و پیاده‌سازی هوش مصنوعی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>شناسایی کاربردهای هوش مصنوعی در کسب‌وکار شما</li>
                                <li>طراحی و پیاده‌سازی مدل‌های یادگیری ماشین و پردازش داده</li>
                                <li>بهینه‌سازی فرآیندهای سازمانی با استفاده از هوش مصنوعی</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">طراحی راهکارهای بلاکچین برای کسب‌وکارها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ارائه راهکارهای بلاکچین برای افزایش امنیت و شفافیت داده‌ها</li>
                                <li>توسعه و پیاده‌سازی قراردادهای هوشمند</li>
                                <li>طراحی سیستم‌های غیرمتمرکز برای کسب‌وکارهای دیجیتال</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/transaction.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">طراحی و مشاوره در حوزه اینترنت اشیا (IoT)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>بررسی نیازهای سازمان و ارائه راهکارهای هوشمندسازی</li>
                                <li>طراحی سیستم‌های مبتنی بر اینترنت اشیا برای نظارت و کنترل هوشمند</li>
                                <li>تجزیه و تحلیل داده‌های IoT برای بهینه‌سازی عملکرد</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5"> مشاوره و طراحی زیرساخت‌های داده و پردازش کلان داده (Big Data)</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل و طراحی پایگاه‌های داده مقیاس‌پذیر</li>
                                <li>بهینه‌سازی سیستم‌های مدیریت داده برای افزایش بهره‌وری</li>
                                <li>پردازش و تحلیل داده‌های کلان برای تصمیم‌گیری‌های هوشمند</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/digital.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img7.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مشاوره در زمینه امنیت سایبری و حفاظت از داده‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ارزیابی امنیتی سیستم‌ها و ارائه راهکارهای حفاظتی</li>
                                <li>پیاده‌سازی پروتکل‌های امنیتی برای جلوگیری از تهدیدات سایبری</li>
                                <li>طراحی سیستم‌های رمزنگاری و کنترل دسترسی</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Logistics.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">طراحی نرم‌افزارهای سفارشی و یکپارچه‌سازی سیستم‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>توسعه نرم‌افزارهای سازمانی متناسب با نیازهای کسب‌وکار</li>
                                <li>سفارشی‌سازی و یکپارچه‌سازی سیستم‌های مدیریت سازمانی (ERP، CRM و ...)</li>
                                <li>بهینه‌سازی فرآیندهای کسب‌وکار با راهکارهای نرم‌افزاری پیشرفته</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img23.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای کسب‌وکارها</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش بهره‌وری و کاهش هزینه‌ها </strong>با پیاده‌سازی فناوری‌های نوین 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img4.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>اتخاذ تصمیمات هوشمندانه‌تر </strong>از طریق استفاده از داده‌های تحلیلی
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت و شفافیت فرآیندها </strong>با بهره‌گیری از بلاکچین و امنیت سایبری 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت و شفافیت فرآیندها </strong>با بهره‌گیری از بلاکچین و امنیت سایبری 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی عملکرد سازمانی و فرآیندهای کاری</strong> با استفاده از هوش مصنوعی و یادگیری ماشین 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Running.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>ایجاد مزیت رقابتی پایدار</strong> از طریق استفاده از تکنولوژی‌های پیشرفته 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>آیا خدمات مشاوره و طراحی تکنولوژی برای همه‌ی کسب‌وکارها مناسب است؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        بله، ما راهکارهای خود را متناسب با نیازهای هر کسب‌وکار، از استارتاپ‌ها تا شرکت‌های بزرگ، ارائه می‌دهیم.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6> چگونه می‌توانم مشاوره بگیرم؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        برای دریافت مشاوره، کافی است با تیم ما تماس بگیرید تا نیازهای شما بررسی شده و بهترین راهکارها ارائه شوند.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>آیا خدمات شما شامل آموزش نیز می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما علاوه بر ارائه راهکارهای فناوری، آموزش‌های لازم را نیز به کارکنان سازمان‌ها ارائه می‌دهیم تا بتوانند از این فناوری‌ها بهره ببرند.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>چه تضمینی برای امنیت داده‌های ما وجود دارد؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما از پیشرفته‌ترین راهکارهای امنیتی و رمزنگاری برای حفاظت از داده‌های شما استفاده می‌کنیم تا اطلاعات شما در بالاترین سطح امنیت باقی بماند.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>آیا خدمات شما شامل پیاده‌سازی نیز می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما علاوه بر مشاوره، خدمات پیاده‌سازی و اجرای راهکارهای تکنولوژی را نیز ارائه می‌دهیم تا مشتریان ما بتوانند به بهترین شکل از این فناوری‌ها بهره‌برداری کنند.
                        <br>
                        ما در کنار شما هستیم تا با استفاده از تکنولوژی‌های روز، آینده‌ای هوشمندتر و کارآمدتر برای کسب‌وکار شما رقم بزنیم. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>